<app-gov-site-link />
<app-toast [toasts]="(notifications$ | async) ?? []" [autoCloseDelay]="5" />
<router-outlet />
<footer>
  <app-connect-opa-footer />
  <app-footer />
</footer>
